import * as Sentry from '@sentry/react';
import {
  InfiniteData,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { leaveChatRoom } from '~/api';
import { GetChatRoomListResponse } from '~/types';
import useToast from '~/store/useToast';
import chatRoomKey from './chatRoomKey';

const useLeaveChatRoomMutation = () => {
  const queryClient = useQueryClient();
  const { showToast } = useToast();

  return useMutation({
    mutationFn: leaveChatRoom,
    onError: (error) => {
      console.error(error);
      showToast('error', 'cannot leave chat');
    },
    onSuccess: ({ status }, request) => {
      const previousAssets = queryClient.getQueryData<
        InfiniteData<GetChatRoomListResponse, number>
      >(chatRoomKey.getChatList());

      if (previousAssets) {
        queryClient.setQueryData<InfiniteData<GetChatRoomListResponse, number>>(
          chatRoomKey.getChatList(),
          {
            ...previousAssets,
            pages: previousAssets.pages.map((page) => {
              if (page.data) {
                return {
                  ...page,
                  data: page.data.filter(
                    (el) => el.chatroom_uuid !== request.chatroom_id,
                  ),
                };
              }
              return page;
            }),
          },
        );
      }

      queryClient.invalidateQueries({
        queryKey: chatRoomKey.getChatList(),
        refetchType: 'all',
      });
    },
  });
};

export default useLeaveChatRoomMutation;
